<template>
    <framework>
        <template #side>
            <side-panel-nav/>
        </template>
        <template #main>
            <main-header title="Study Activity" icon="fa-calendar-days"/>

            <div class="mt-6 pb-6">
                <div class="content mb-5">
                    <p class="has-text-white" style="max-width: 75ch;">
                        All of your logged time in one place — online course study, offline
                        activities, and conference attendance across every enrollment and
                        registration on your account.
                    </p>
                </div>

                <study-activity-panel :months="12"/>
            </div>
        </template>
    </framework>
</template>

<script>
import Framework from '@/components/framework/Framework';
import SidePanelNav from '@/components/framework/SidePanelNav';
import MainHeader from '@/components/framework/MainHeader';
import StudyActivityPanel from '@/components/studyActivity/StudyActivityPanel';

export default {
    name: 'StudyActivity',
    components: {Framework, SidePanelNav, MainHeader, StudyActivityPanel},
};
</script>
